import The404 from "@/views/The404";

export default [
    {
        path: '/office',
        component: () => import('@/views/cabinet/TheCabinet.vue'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '/',
                name: 'home',
                component: () => import(/* webpackChunkName: "dashboard"*/'@/views/cabinet/TheSpace.vue'),
            },
            {
                path: 'transactions',
                name: 'transactions',
                component: () => import(/* webpackChunkName: "transactions"*/'@/views/cabinet/Money/TheTransactions.vue'),
                meta: {
                    spaceRequired: true,
                }
            },
            {
                path: 'investments',
                component: () => import(/* webpackChunkName: "investments"*/'@/views/cabinet/Investments/TheInvestments.vue'),
                meta: {
                    spaceRequired: true,
                },
                children: [
                    {
                        path: '',
                        name: 'investments',
                        component: () => import(/* webpackChunkName: "investments-dashboard"*/ '@/views/cabinet/Investments/TheInvestmentsDashboard.vue'),
                    },
                    {
                        path: 'assets',
                        name: 'investments-assets',
                        component: () => import(/* webpackChunkName: "investments-assets"*/ '@/views/cabinet/Investments/TheInvestmentsAssets.vue'),
                    },
                    {
                        path: 'deals',
                        name: 'investments-deals',
                        component: () => import(/* webpackChunkName: "investments-deals"*/ '@/views/cabinet/Investments/TheInvestmentsDeals.vue'),
                    },
                    {
                        path: 'analytics',
                        name: 'investments-analytics',
                        component: () => import(/* webpackChunkName: "investments-analytics"*/ '@/views/cabinet/Investments/TheInvestmentsAnalytics.vue'),
                    },
                ]
            },
            {
                path: 'reports',
                name: 'reports',
                component: () => import(/* webpackChunkName: "reports"*/'@/views/cabinet/Money/TheReports.vue'),
                meta: {
                    spaceRequired: true,
                }
            },
            {
                path: 'budget',
                name: 'budget',
                component: () => import(/* webpackChunkName: "budgets"*/'@/views/cabinet/Money/TheBudgets.vue'),
                meta: {
                    spaceRequired: true,
                }
            },
            {
                path: 'goals',
                name: 'goals',
                component: () => import(/* webpackChunkName: "goals"*/'@/views/cabinet/Money/TheGoals.vue'),
                meta: {
                    spaceRequired: true,
                }
            },
            {
                path: 'calendar',
                name: 'calendar',
                component: () => import(/* webpackChunkName: "calendar"*/'@/views/cabinet/Money/TheCalendar.vue'),
                meta: {
                    spaceRequired: true,
                }
            },
            {
                path: 'settings/bookkeeping/add',
                name: 'create-accounting',
                component: () => import(/* webpackChunkName: "settings"*/ '@/views/cabinet/CreateSpace.vue'),
            },
            {
                path: 'settings/bookkeeping',
                component: () => import(/* webpackChunkName: "settings"*/ '@/views/cabinet/Settings/TheSpaceSettings.vue'),
                children: [
                    {
                        path: '',
                        name: 'settings-space',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/SpaceSettings/SpaceSettings.vue'),
                    },
                    {
                        path: 'accounts',
                        name: 'settings-accounts',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/AccountsSettings/AccountsSettings.vue'),
                    },
                    {
                        path: 'budget-income',
                        name: 'settings-income',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/IncomeSettings/IncomeSettings.vue'),
                    },
                    {
                        path: 'budget-expense',
                        name: 'settings-expense',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseSettings.vue'),
                    },
                    {
                        path: 'contractors',
                        name: 'settings-contractors',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/ContractorsSettings/ContractorsSettings.vue'),
                    },
                    {
                        path: 'access',
                        name: 'settings-access',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/AccessSettings/AccessSettings.vue'),
                    },
                    {
                        path: 'calendar',
                        name: 'settings-calendar',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/CalendarSettings/CalendarSettings.vue'),
                    },
                    {
                        path: 'invest-profile',
                        name: 'invest-profile',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/InvestmentsSettings/InvestmentsSettings.vue'),
                    },
                    {
                        path: 'banks-integrations',
                        name: 'banks-integrations',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/BanksIntegrations/TheBanksIntegrations.vue'),
                    },
                    {
                        path: 'trash',
                        name: 'trash',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/Trash/Trash.vue'),
                    },
                    {
                        path: 'tags',
                        name: 'settings-tags',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/SpaceSettings/TagsSettings/TagsSettings.vue'),
                    }
                ]
            },
            {
                name: 'wizard',
                path: 'wizard',
                component: () => import(/* webpackChunkName: "wizard"*/ '@/views/cabinet/Wizard/TheWizard.vue'),
            },
            {
                path: 'settings/profile',
                component: () => import(/* webpackChunkName: "profile"*/'@/views/cabinet/Settings/TheProfile.vue'),
                children: [
                    {
                        path: '',
                        name: 'profile-settings',
                        component: () => import(/* webpackChunkName: "profile"*/'@/components/cabinet/ProfileSettings/TheProfileSettings.vue'),
                    },
                    {
                        path: 'personalization',
                        name: 'personalization',
                        component: () => import(/* webpackChunkName: "profile"*/'@/components/cabinet/ProfileSettings/ThePersonalization.vue'),
                    },
                    {
                        path: 'notifications',
                        name: 'notifications',
                        component: () => import(/* webpackChunkName: "profile"*/'@/components/cabinet/ProfileSettings/TheNotifications.vue'),
                    },
                    {
                        path: 'theming',
                        name: 'theming',
                        component: () => import(/* webpackChunkName: "profile"*/'@/components/cabinet/ProfileSettings/TheTheming.vue'),
                    },
                    {
                        path: 'sessions',
                        name: 'sessions',
                        component: () => import(/* webpackChunkName: "profile"*/'@/components/cabinet/ProfileSettings/TheSessions.vue'),
                    },
                    {
                        path: 'api',
                        name: 'user-api',
                        component: () => import(/* webpackChunkName: "settings"*/ '@/components/cabinet/ProfileSettings/APISettings/TheAPISettings.vue'),
                    },
                ]
            },
            {
                path: 'support',
                component: () => import(/* webpackChunkName: "support"*/'@/views/cabinet/Tickets/TheTickets.vue'),
                children: [
                    {
                        path: '',
                        name: 'ticket-system',
                        component: () => import(/* webpackChunkName: "support"*/'@/views/cabinet/Tickets/TheTicketsSystem.vue'),
                    },
                    {
                        path: 'ticket/:ticketId',
                        name: 'ticket-chat',
                        component: () => import(/* webpackChunkName: "support"*/'@/views/cabinet/Tickets/TheTicketsChat.vue'),
                    },
                    {
                        path: 'faq',
                        name: 'faq',
                        component: () => import(/* webpackChunkName: "support"*/'@/views/cabinet/Tickets/TheTicketsFAQ.vue'),
                    },
                ]
            },
        ]
    },

    {
        path: '/',
        component: () => import(/* webpackChunkName: "unauthorized"*/'@/views/guests/TheGuest.vue'),
        children: [
            {
                path: 'login',
                name: 'login',
                component: () => import(/* webpackChunkName: "unauthorized"*/'@/views/guests/Login/Login.vue'),
                meta: {
                    forGuest: true
                }
            },
            {
                path: 'signup',
                name: 'register',
                component: () => import(/* webpackChunkName: "unauthorized"*/'@/views/guests/Register.vue'),
                meta: {
                    forGuest: true
                }
            },
            {
                path: 'restore',
                name: 'restore',
                component: () => import(/* webpackChunkName: "unauthorized"*/'@/views/guests/RestorePassword.vue'),
                meta: {
                    forGuest: true
                }
            },
            {
                path: 'password/:token?',
                name: 'password_reset',
                component: () => import(/* webpackChunkName: "unauthorized"*/'@/views/guests/PasswordRecovery.vue'),
                meta: {
                    forGuest: true
                }
            },
            {
                path: 'email-confirmation/:token?',
                name: 'verify_email',
                component: () => import(/* webpackChunkName: "unauthorized"*/'@/views/guests/MailVerification.vue'),
            },
        ]
    },
    {
        path: '*',
        name: '404 | not found',
        component: The404
    }
]
